export default function SavedFiltersModalController(
  $scope,
  $rootScope,
  $filter,
  $uibModal,
  $uibModalInstance,
  $state,
  gettextCatalog,
  savedFilterService,
) {
  'ngInject';

  const userId = $rootScope.currentUser.id;
  const addToDataLayer = (data) => window.dataLayer.push(data);

  $scope.savedFiltersModels = []; //full list of saved search filters
  $scope.savedFiltersModelByPage = [];
  $scope.filteredSavedFilters = [];
  $scope.selectedFilters = {};
  $scope.searchString = '';
  $scope.editing = {};
  $scope.editSavedFilter = {};
  $scope.postingChange = false;
  $scope.conflictErrorFlag = false;
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.loading = true;
  $scope.disabled = {
    edit: false,
  };
  $scope.isInvalidData = false;

  //Pagination
  $scope.current = {
    savedFiltersPage: 1,
  };
  $scope.itemsPerPage = 3;
  $scope.maxSize = 1;

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;

  let orderBy = $filter('orderBy');

  //Editing
  $scope.toggleEditing = function (savedFilter) {
    $scope.editing[savedFilter.id] = !$scope.editing[savedFilter.id];
    $scope.editSavedFilter.name = savedFilter.name;
    $scope.editSavedFilter.description = savedFilter.description;
    $scope.disabled.edit = true;
  };

  $scope.cancelEdit = function (savedFilter) {
    $scope.editing[savedFilter.id] = !$scope.editing[savedFilter.id];
    $scope.editSavedFilter.name = '';
    $scope.editSavedFilter.description = '';
    $scope.disabled.edit = false;
  };

  //Sort filteredSavedFilters
  $scope.orderSavedFilter = function (predicate) {
    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = false;
    }
    $scope.predicate = predicate;

    angular.forEach($scope.savedFiltersModels, function (savedFilterModel) {
      savedFilterModel[predicate] = savedFilterModel[predicate];
    });

    $scope.savedFiltersModels = orderBy($scope.savedFiltersModels, predicate, $scope.reverse);
    $scope.applyFilter();
  };

  // savedFilters per page
  $scope.displaySavedFiltersByPage = function () {
    $scope.totalItems = $scope.filteredSavedFilters.length;
    let begin = ($scope.current.savedFiltersPage - 1) * $scope.itemsPerPage;
    let end = begin + $scope.itemsPerPage;
    $scope.savedFiltersModelByPage = $scope.filteredSavedFilters.slice(begin, end);
  };

  let filterDebouncer = null;

  //applyFilter searchs on savedFiltersModels[] for anything matching the search input.
  $scope.applyFilter = function () {
    $scope.filteredSavedFilters = $filter('filter')($scope.savedFiltersModels, $scope.searchString);
    $scope.displaySavedFiltersByPage();

    if (filterDebouncer !== null) clearTimeout(filterDebouncer);

    filterDebouncer = setTimeout(() => {
      addToDataLayer({
        event: 'savedFiltersSearching',
        data: {
          keyword: $scope.searchString,
        },
      });
    }, 500);
  };

  //on selected page changed
  $scope.pageChanged = function () {
    $scope.displaySavedFiltersByPage();
  };

  // called after change happend to savedFiltersModels to update the table
  $scope.updateFiltersList = function () {
    $scope.filteredSavedFilters = $scope.savedFiltersModels.slice();
    $scope.displaySavedFiltersByPage();
  };

  // watch seach then apply it
  $scope.$watch('searchString', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      $scope.applyFilter();
    }
  });

  // watch savedFiltersModels then create model with remove flags
  $scope.$watch('savedFiltersModels', function () {
    $scope.updateFiltersList();
  });

  //clear the conflict message when user changes the name field
  $scope.$watch('editSavedFilter.name', function (newVal, oldVal) {
    //compare
    if (newVal !== oldVal) {
      $scope.conflictErrorFlag = false;
    }
  });

  //Validate the form on submission then run the API call
  $scope.isFormValid = function (editSavedFilterForm, savedFilter) {
    editSavedFilterForm.$setSubmitted();
    if (editSavedFilterForm.$invalid) {
      //$scope.loading = false;
      return;
    } else {
      $scope.updateFilter(savedFilter);
    }
  };

  //Saved Search Filters
  $scope.getSavedFilters = function () {
    $scope.loading = true;
    savedFilterService
      .getAllSavedFilters(userId)
      .then(function (response) {
        $scope.savedFiltersModels = response.data.reverse();
        $scope.loading = false;
      })
      .catch(function (error) {
        let errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving Saved Filter information. Please try again later.',
        );
        if (error) {
          if (!!error.data && !!error.data.message && !!error.status && !!error.statusText) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else if (!!error.status && !!error.statusText) {
            errorMsg =
              gettextCatalog.getString(
                'An error occurred while retrieving Saved Filter information: ',
              ) +
              (error.status.toString() + ' - ' + error.statusText.toString());
          }
        }
        $scope.errorFlag = true;
        $scope.errorText = errorMsg;
      })
      .finally(function () {
        $scope.loading = false;
      });
  }; //getSavedFilters

  $scope.getSavedFilters();

  $scope.updateFilter = function (savedFilter) {
    if ($scope.editSavedFilter.name !== '') {
      savedFilter.description = $scope.editSavedFilter.description;
      savedFilter.name = $scope.editSavedFilter.name;
      $scope.postingChange = true;

      savedFilterService
        .updateSavedFilter(savedFilter.id, savedFilter)
        .then(function () {
          $scope.editing[savedFilter.id] = !$scope.editing[savedFilter.id];
          $scope.postingChange = false;
          $scope.disabledOnEdit = false;
          $scope.disabled.edit = false;
        })
        .catch(function (error) {
          if (error.status === 409) {
            $scope.conflictErrorFlag = true;
            $scope.postingChange = false;
          } else {
            let errorMsg = gettextCatalog.getString(
              'An error occurred while updating Saved Filter information. Please try again later.',
            );
            if (error) {
              if (!!error.data && !!error.data.message && !!error.status && !!error.statusText) {
                errorMsg =
                  error.data.message +
                  ' ' +
                  (error.status.toString() + ' - ' + error.statusText.toString());
              } else if (!!error.status && !!error.statusText) {
                errorMsg =
                  gettextCatalog.getString(
                    'An error occurred while updating Saved Filter information: ',
                  ) +
                  (error.status.toString() + ' - ' + error.statusText.toString());
              }
            }
            $scope.errorFlag = true;
            $scope.errorText = errorMsg;
            $scope.disabledOnEdit = false;
            $scope.disabled.edit = false;
          }
        })
        .finally(function () {
          $scope.postingChange = false;
        });
    } else {
      $scope.isInvalidData = true;
    }
  }; //end updateSavedFilter

  $scope.deleteBtnClicked = function (savedFilterId) {
    if (savedFilterId) {
      //$scope.savedFiltersModels = [];
      let modalInstance = $uibModal.open({
        animation: true,
        template: require('./saved-filters-delete-modal.html'),
        controller: 'SavedFiltersDeleteModalController',
        resolve: {
          savedFilterId: function () {
            return savedFilterId;
          },
        },
        size: 'md',
      });

      //modal dialog result
      modalInstance.result.then(
        function (savedFiltersModels) {
          $scope.savedFiltersModels = savedFiltersModels;
        },
        function () {},
      );
    } else {
      $uibModalInstance.dismiss();
    }
  };

  $scope.update = function (savedFilter) {
    $scope.selectedFilters = savedFilter;
    $scope.ok();
  };

  $scope.ok = function () {
    $uibModalInstance.close($scope.selectedFilters);
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };

  $scope.$on('$locationChangeStart', function (event) {
    event.preventDefault();
  });
}
